var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4V11C22 11.5304 21.7893 12.0391 21.4142 12.4142C21.0391 12.7893 20.5304 13 20 13L4 13C3.46956 13 2.96086 12.7893 2.58578 12.4142C2.21071 12.0391 2 11.5304 2 11V4C2 3.46957 2 2.00005 2 2.00005C2 2.00005 3.46956 2 4 2L20 2C20.5304 2 22 2.00009 22 2.00009C22 2.00009 22 3.46957 22 4ZM14 4L10 4V11H14V4ZM8 4L4 4V11H8V4ZM20 4L16 4V11H20V4ZM12 17.59L14.59 15L16 16.41L13.41 19L16 21.59L14.59 23L12 20.41L9.41 23L8 21.59L10.59 19L8 16.41L9.41 15L12 17.59Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRow);
export default __webpack_public_path__ + "static/media/remove_row.f56906147b072b328111bc2a2460511b.svg";
export { ForwardRef as ReactComponent };